module.exports = __webpack_public_path__ + "static/media/galleryImg23.2969538a.jpg";